var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0912 6.68811C18.338 6.68811 20.1667 8.57626 20.1667 10.8969V15.5099C20.1667 17.8249 18.3426 19.7083 16.1004 19.7083H5.91075C3.66308 19.7083 1.83341 17.8211 1.83341 15.5004V10.8875C1.83341 8.57247 3.6585 6.68811 5.90158 6.68811H6.76325L16.0912 6.68811Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5006 14.7009L14.1671 11.9803C14.4421 11.6991 14.4421 11.2466 14.1653 10.9664C13.8885 10.6871 13.4421 10.688 13.1671 10.9683L11.7068 12.458L11.7068 3.00855C11.7068 2.61284 11.3906 2.29163 11.0001 2.29163C10.6105 2.29163 10.2951 2.61284 10.2951 3.00855L10.2951 12.458L8.83398 10.9683C8.55898 10.688 8.11256 10.6871 7.83573 10.9664C7.69731 11.107 7.62765 11.2904 7.62765 11.4748C7.62765 11.6572 7.69731 11.8407 7.8339 11.9803L10.5005 14.7009C10.6334 14.8359 10.8131 14.9123 11.0001 14.9123C11.188 14.9123 11.3676 14.8359 11.5006 14.7009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackIcon);
export default __webpack_public_path__ + "static/media/blackIcon.a580f844e2b3d3c4adc363810c13652b.svg";
export { ForwardRef as ReactComponent };